<template>
  <v-col class="px-0 py-0">
    <v-expansion-panels flat>
      <v-expansion-panel @change="isPanelExpanded = !isPanelExpanded" fluid>
        <v-divider v-if="displayUpperDivider"></v-divider>

        <v-expansion-panel-header
          class="pl-0 py-0 pr-3-5"
          expand-icon="mdi-chevron-down"
          collapse-icon="mdi-chevron-up"
        >
          <div :class="panelHeader">
            <span v-if="isPanelExpanded">{{ panelTextHide }}</span>
            <span v-else>{{ panelTextShow }}</span>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-row>
            <v-col
              v-for="item in items"
              :key="item._id?.$oid || item._id"
              cols="12"
              xl="6"
              class="d-flex align-center py-0"
            >
              <!-- Slot for the left column -->
              <slot name="left" :item="item"></slot>

              <!-- When an URL is available -->
              <a
                v-if="getField(item, urlField)"
                :href="getField(item, urlField)"
                target="_blank"
                rel="noopener noreferrer"
                class="document-link"
              >
                <v-card-text :class="referenceFieldFontClass">
                  {{ getField(item, referenceField) }}
                </v-card-text>
              </a>

              <!-- When no URL -->
              <v-card-text v-else :class="referenceFieldFontClass" class="document-link">
                {{ getField(item, referenceField) }}
              </v-card-text>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
  export default {
    name: 'GenericExpandableList',

    props: {
      items: {
        type: Array,
        required: true,
      },
      panelTextShow: {
        type: String,
        required: true,
      },
      panelTextHide: {
        type: String,
        required: true,
      },
      referenceField: {
        type: String,
        required: true,
      },
      urlField: {
        type: String,
        required: true,
      },
      displayUpperDivider: {
        type: Boolean,
        default: true,
      },
    },

    data() {
      return {
        isPanelExpanded: false,
      }
    },

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.width < 650
      },

      referenceFieldFontClass() {
        return this.isMobile ? 'white-space-normal pa-2 caption' : 'white-space-normal pa-2 body-2'
      },

      panelHeader() {
        const baseMobile = 'text-uppercase py-0 pl-1'
        const baseDesktop = 'text-uppercase py-0 pl-4'
        const mobile = 'v-list-item__subtitle ' + baseMobile
        const desktop = 'v-list-item__title ' + baseDesktop
        return this.isMobile ? mobile : desktop
      },
    },
    methods: {
      // Returns a nested value from an object given a path like a.b.c
      resolvePath(obj, path) {
        return path.split('.').reduce((acc, key) => acc && acc[key], obj)
      },

      // Replaces only expressions starting with "item." in a template string
      interpolate(template, item) {
        return template.replace(/item(\.[a-zA-Z0-9_]+)+/g, (match) => {
          const path = match.replace('item.', '')
          const value = this.resolvePath(item, path)
          return value !== undefined && value !== null ? value : ''
        })
      },

      // Returns the value for a field
      // If the field contains "item.", it evaluates it
      // Otherwise, it returns the text literally
      getField(item, fieldName) {
        if (!item || !fieldName) return undefined

        if (fieldName.includes('item.')) {
          return this.interpolate(fieldName, item)
        }

        // Return literal text if it does not start with "item."
        return fieldName
      },
    },
  }
</script>

<style scoped>
  .white-space-normal {
    white-space: normal;
    word-break: break-word;
  }
  .document-link {
    text-transform: none;
    text-decoration: underline;
  }
  .pr-3-5 {
    padding-right: 14px !important;
  }
  .v-expansion-panel-header >>> .v-icon {
    color: var(--v-primary-base) !important;
  }
</style>
